export enum AppDisplayModes {
  browserTab = 'BROWSER_TAB',
  standaloneAndroid = 'STANDALONE_ANDROID',
  standaloneIOS = 'STANDALONE_IOS',
}

export default AppDisplayModes
